const ARENA_SRC = "/wp-content/themes/tickets-hawk/assets/calendar/img/arena.svg";

const PRODUCT_PRICES = {
  vse: {
    1: [119590, 113610, 107631, 95672, 89692, 77733],
    2: [83390, 79220, 75051, 66712, 62542, 54203],
    3: [60590, 57560, 54531, 48472, 45442, 39383],
    4: [46790, 44450, 42111, 37432, 35092, 30413],
    5: [35790, 34000, 32211, 28632, 26842, 23263],
    6: [24790, 23550, 22311, 19832, 18592, 16113],
    7: [16790, 15950, 15111, 13432, 12592, 10913],
    8: [12390, 11770, 11151, 9912, 9292, 8053]
  },
  sez: {
    1: [99790, 94800, 89811, 79832, 74842, 64863],
    2: [67190, 63830, 60471, 53752, 50392, 43673],
    3: [47990, 45590, 43191, 38392, 35992, 31193],
    4: [37990, 36090, 34191, 30392, 28492, 24693],
    5: [28590, 27160, 25731, 22872, 21442, 18583],
    6: [19190, 18230, 17271, 15352, 14392, 12473],
    7: [12790, 12150, 11511, 10232, 9592, 8313],
    8: [9390, 8920, 8451, 7512, 7042, 6103]
  },
  vyh: {
    1: [46190, 43880, 41571, 36952, 34642, 30023],
    2: [33190, 31530, 29871, 26552, 24892, 21573],
    3: [24390, 23170, 21951, 19512, 18292, 15853],
    4: [20190, 19180, 18171, 16152, 15142, 13123],
    5: [15790, 15000, 14211, 12632, 11842, 10263],
    6: [10590, 10060, 9531, 8472, 7942, 6883],
    7: [7790, 7400, 7011, 6232, 5842, 5063],
    8: [5990, 5690, 5391, 4792, 4492, 3893]
  },
  start: {
    1: [10490, 9965, 9441, 8392, 7867, 6818],
    2: [6990, 6640, 6291, 5592, 5242, 4543],
    3: [4990, 4740, 4491, 3992, 3742, 3243],
    4: [3990, 3790, 3591, 3192, 2992, 2593],
    5: [2990, 2840, 2691, 2392, 2242, 1943],
    6: [1990, 1890, 1791, 1592, 1492, 1293],
    7: [1390, 1320, 1251, 1112, 1042, 903],
    8: [990, 940, 891, 792, 742, 643]
  }
};

const TICKET_PRICES = {
  vse: {1: 141070, 2: 105870, 3: 77970, 4: 64170, 5: 48170, 6: 33670, 7: 24770, 8: 18270},
  sez: {1: 105160, 2: 74760, 3: 53460, 4: 44760, 5: 33860, 6: 22660, 7: 16160, 8: 11760},
  vyh: {1: 46370, 2: 33370, 3: 24470, 4: 20370, 5: 15870, 6: 10670, 7: 7870, 8: 6170},
  start: {1: 12460, 2: 9060, 3: 6360, 4: 5260, 5: 3960, 6: 2760, 7: 1860, 8: 1460}
};

const STATUSES = [
  {name: "Новичок", discount: 0},
  {name: "Игрок", discount: 5},
  {name: "Ассистент", discount: 10},
  {name: "Капитан", discount: 20},
  {name: "Тренер", discount: 25},
  {name: "Первооткрыватель", discount: 35}
];

const ZONE_COLORS = {
  1: "#77081A",
  2: "#970E21",
  3: "#BE1327",
  4: "#F0282E",
  5: "#F45C5E",
  6: "#F98D8E",
  7: "#FBB6B8",
  8: "#D89A9B"
};

const INACTIVE_ARENA_OPACITY = "0.15";
const INACTIVE_SPLIT_FILL = "rgb(246 207 210)";
const INACTIVE_SPLIT_OPACITY = "0.9";
const ARENA_STROKE_WIDTH = "1";

const INACTIVE_SPLIT_PATHS = [
  2, 3, 19, 20, 21, 22, 28, 29, 30, 31, 32, 33, 34, 35,
  57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
  107, 108, 109, 110, 216, 217, 218, 219, 220, 221, 222, 223,
  236, 237, 238, 239, 240, 241, 242, 243, 256, 257
];

const SECTION_LABEL_PATHS = [
  38, 39, 40, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81,
  82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95,
  96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106,
  114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
  125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135,
  136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146,
  147, 148, 149, 186, 187, 188, 189, 190, 191, 244, 245,
  246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 261,
  262, 263, 264, 265, 266, 267, 268, 269
];

const ARENA_CLICK_PATHS = {
  1: [23, 24, 25, 185, 258, 260],
  2: [2, 19, 21, 256],
  3: [3, 20, 22, 107, 109, 257],
  4: [108, 110, 111, 218, 219, 240, 241],
  5: [112, 113, 216, 220, 221, 222, 236, 238, 239, 242],
  6: [28, 34, 57, 59, 65, 67, 69, 217, 223, 237, 243],
  7: [29, 30, 32, 35, 58, 60, 61, 63, 66, 68, 70],
  8: [31, 33, 62, 64]
};

const ARENA_HIGHLIGHT_PATHS = {
  1: {
    "#77081A": [23, 24, 25, 185, 258, 260],
  },
  2: {
    "#970E21": [2, 19, 21, 256]
  },
  3: {
    "#BE1327": [3, 20, 22, 107, 109, 257],
    "#FEDCDC": [62, 64]
  },
  4: {
    "#F0282E": [108, 110, 111, 218, 219, 240, 241]
  },
  5: {
    "#F45C5E": [112, 113, 216, 220, 221, 222, 236, 238, 239, 242],
    "#FBB6B8": [237, 243]
  },
  6: {
    "#F98D8E": [28, 34, 57, 59, 65, 67, 69, 217, 223, 237, 243]
  },
  7: {
    "#FBB6B8": [29, 30, 32, 35, 58, 60, 61, 63, 66, 68, 70],
    "#FEDCDC": [31, 33, 62, 64]
  },
  8: {
    "#D89A9B": [31, 33, 62, 64]
  }
};
const formatPrice = (value) => `${value.toLocaleString("ru-RU")} ₽`;

const isPaintedArenaPath = (el) => {
  const fill = String(el.getAttribute("fill") || "").trim().toLowerCase();

  return fill && fill !== "none" && fill !== "white" && fill !== "#fff" && fill !== "#ffffff";
};

const getArenaClickZones = () => Object.entries(ARENA_CLICK_PATHS).reduce((acc, [zone, paths]) => {
  paths.forEach((pathIndex) => {
    acc[pathIndex] = Number(zone);
  });

  return acc;
}, {});

const getArenaHighlights = () => Object.entries(ARENA_HIGHLIGHT_PATHS).reduce((acc, [zone, fills]) => {
  Object.entries(fills).forEach(([fill, paths]) => {
    paths.forEach((pathIndex) => {
      if (!acc[pathIndex]) acc[pathIndex] = [];
      acc[pathIndex].push({zone: Number(zone), fill});
    });
  });

  return acc;
}, {});

const createStatusButton = (status, index, onSelect) => {
  const button = document.createElement("button");
  button.className = `btn-reset aboniment-prices__status${index === 0 ? " active" : ""}`;
  button.type = "button";
  button.setAttribute("aria-pressed", index === 0 ? "true" : "false");

  const name = document.createElement("span");
  name.className = "aboniment-prices__status-name";
  name.textContent = status.name;
  button.appendChild(name);

  if (status.discount) {
    const discount = document.createElement("span");
    discount.className = "aboniment-prices__discount";
    discount.textContent = `${status.discount}%`;
    button.appendChild(discount);
  }

  button.addEventListener("click", () => onSelect(index));
  return button;
};

const createLegendRow = ({zone, product, statusIndex, selectedZone, onSelect}) => {
  const price = PRODUCT_PRICES[product][zone][statusIndex];
  const ticketPrice = TICKET_PRICES[product][zone];

  const row = document.createElement("button");
  row.className = `btn-reset aboniment-prices__row${zone === selectedZone ? " active" : ""}`;
  row.type = "button";
  row.setAttribute("aria-pressed", zone === selectedZone ? "true" : "false");

  const swatch = document.createElement("span");
  swatch.className = "aboniment-prices__swatch";
  swatch.style.background = ZONE_COLORS[zone];
  row.appendChild(swatch);

  const zoneBox = document.createElement("span");
  zoneBox.className = "aboniment-prices__zone";

  const line = document.createElement("span");
  line.className = "aboniment-prices__line";

  const zoneName = document.createElement("span");
  zoneName.className = "aboniment-prices__zone-name";
  zoneName.textContent = `Зона ${zone}`;
  line.appendChild(zoneName);

  const oldPrice = document.createElement("span");
  oldPrice.className = "aboniment-prices__ticket-price";
  oldPrice.textContent = `${formatPrice(ticketPrice)}`;
  line.appendChild(oldPrice);

  const currentPrice = document.createElement("span");
  currentPrice.className = "aboniment-prices__price";
  currentPrice.textContent = formatPrice(price);
  line.appendChild(currentPrice);

  const benefit = document.createElement("span");
  benefit.className = "aboniment-prices__benefit";
  const benefitValue = document.createElement("span");
  benefitValue.textContent = `Выгода ${formatPrice(ticketPrice - price)}`;
  benefit.appendChild(benefitValue);

  zoneBox.appendChild(line);
  zoneBox.appendChild(benefit);
  row.appendChild(zoneBox);

  row.addEventListener("click", () => onSelect(zone));
  return row;
};

const parseSvg = (svgText) => {
  const parsed = new DOMParser().parseFromString(svgText, "image/svg+xml");
  const svg = parsed.documentElement;

  if (svg.nodeName.toLowerCase() === "parsererror") {
    throw new Error("Invalid arena SVG");
  }

  return document.importNode(svg, true);
};

const annotateArenaZones = (svg) => {
  svg.classList.add("aboniment-prices__svg");
  svg.setAttribute("role", "img");
  svg.setAttribute("aria-label", "Схема ценовых зон G-Drive Арены");

  const clickZones = getArenaClickZones();
  const highlights = getArenaHighlights();

  svg.querySelectorAll("path").forEach((el, index) => {
    const clickZone = clickZones[index];
    const pathHighlights = highlights[index];
    const shouldMute = isPaintedArenaPath(el) || pathHighlights;
    if (!clickZone && !pathHighlights && !shouldMute) return;

    if (clickZone) el.dataset.priceZone = String(clickZone);
    if (pathHighlights) el.dataset.highlightZones = JSON.stringify(pathHighlights);
    if (INACTIVE_SPLIT_PATHS.includes(index)) el.dataset.splitArenaPath = "";
    if (SECTION_LABEL_PATHS.includes(index)) el.dataset.sectionLabelPath = "";
    if (shouldMute) el.dataset.arenaPath = "";
    el.dataset.originalFill = el.getAttribute("fill") || "";
  });
};

const loadArenaSvg = async (arenaBox) => {
  arenaBox.classList.add("is-loading");

  try {
    const response = await fetch(ARENA_SRC);
    if (!response.ok) throw new Error(`Arena SVG request failed: ${response.status}`);

    const svg = parseSvg(await response.text());
    annotateArenaZones(svg);

    arenaBox.innerHTML = "";
    arenaBox.appendChild(svg);
  } catch (error) {
    const img = document.createElement("img");
    img.src = ARENA_SRC;
    img.alt = "Схема ценовых зон G-Drive Арены";
    arenaBox.innerHTML = "";
    arenaBox.appendChild(img);
  } finally {
    arenaBox.classList.remove("is-loading");
  }
};

export default function abonimentPrices() {
  const root = document.querySelector(".js-aboniment-prices");
  if (!root) return;

  const productBox = root.querySelector(".js-aboniment-price-products");
  const statusBox = root.querySelector(".js-aboniment-price-statuses");
  const arenaBox = root.querySelector(".js-aboniment-price-arena");
  const legendBox = root.querySelector(".js-aboniment-price-legend");

  if (!productBox || !statusBox || !arenaBox || !legendBox) return;

  let currentProduct = productBox.querySelector(".active")?.dataset.product || "vse";
  let currentStatusIndex = 0;
  let selectedZone = 0;

  const applyZone = () => {
    arenaBox.querySelectorAll("[data-section-label-path]").forEach((el) => {
      el.style.opacity = selectedZone ? "0" : "";
    });

    arenaBox.querySelectorAll("[data-arena-path]").forEach((el) => {
      const highlights = el.dataset.highlightZones
        ? JSON.parse(el.dataset.highlightZones)
        : [];
      const activeHighlight = selectedZone
        ? highlights.find((item) => item.zone === selectedZone)
        : null;
      const isInactive = selectedZone && !activeHighlight;
      const isSplitPath = highlights.length > 1 || el.dataset.splitArenaPath !== undefined;
      const fill = activeHighlight?.fill
        || (isInactive && isSplitPath ? INACTIVE_SPLIT_FILL : el.dataset.originalFill);

      if (fill) el.setAttribute("fill", fill);
      if (selectedZone && fill) {
        el.setAttribute("stroke", "rgb(255, 255, 255, 0.3)");
        el.setAttribute("stroke-width", ARENA_STROKE_WIDTH);
      } else {
        el.removeAttribute("stroke");
        el.removeAttribute("stroke-width");
      }
      el.style.opacity = isInactive
        ? (isSplitPath ? INACTIVE_SPLIT_OPACITY : INACTIVE_ARENA_OPACITY)
        : "";
    });
  };

  const renderLegend = () => {
    legendBox.innerHTML = "";

    for (let zone = 1; zone <= 8; zone += 1) {
      legendBox.appendChild(createLegendRow({
        zone,
        product: currentProduct,
        statusIndex: currentStatusIndex,
        selectedZone,
        onSelect: (nextZone) => {
          selectedZone = selectedZone === nextZone ? 0 : nextZone;
          renderLegend();
        }
      }));
    }

    applyZone();
  };

  const setProduct = (button) => {
    const product = button.dataset.product;
    if (!product || !PRODUCT_PRICES[product]) return;

    currentProduct = product;
    productBox.querySelectorAll(".aboniment-prices__product").forEach((item) => {
      item.classList.toggle("active", item === button);
    });
    renderLegend();
  };

  statusBox.innerHTML = "";
  STATUSES.forEach((status, index) => {
    statusBox.appendChild(createStatusButton(status, index, (nextIndex) => {
      currentStatusIndex = nextIndex;
      statusBox.querySelectorAll(".aboniment-prices__status").forEach((button, buttonIndex) => {
        const isActive = buttonIndex === nextIndex;
        button.classList.toggle("active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
      renderLegend();
    }));
  });

  productBox.addEventListener("click", (event) => {
    const button = event.target.closest(".aboniment-prices__product");
    if (!button) return;
    setProduct(button);
  });

  arenaBox.addEventListener("click", (event) => {
    const zoneEl = event.target.closest("[data-price-zone]");
    if (!zoneEl || !arenaBox.contains(zoneEl)) return;

    const nextZone = Number(zoneEl.dataset.priceZone);
    selectedZone = selectedZone === nextZone ? 0 : nextZone;
    renderLegend();
  });

  loadArenaSvg(arenaBox).then(applyZone);
  renderLegend();
}
